import React, { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, Phone, ArrowRight, CalendarDays } from "lucide-react";
import Logo from "./Logo";
import { Sheet, SheetContent, SheetTrigger, SheetTitle } from "../ui/sheet";
import { CONTACT } from "../../mock";

const LINKS = [
  { to: "/", label: "Accueil" },
  { to: "/proprietaires", label: "Propriétaires" },
  { to: "/tarifs", label: "Tarifs" },
  { to: "/villes", label: "Villes" },
  { to: "/contact", label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  useEffect(() => setOpen(false), [pathname]);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 transition-[background-color,box-shadow] duration-300 ${scrolled ? "bg-[#faf7f0]/90 backdrop-blur-xl shadow-[0_6px_30px_-12px_rgba(19,38,28,0.25)]" : "bg-[#faf7f0]"}`}
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-[76px] flex items-center justify-between">
        <Logo />
        <nav className="hidden lg:flex items-center gap-1">
          {LINKS.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `relative px-4 py-2 rounded-full text-[15px] font-semibold transition-colors ${isActive ? "text-[#c4703f] bg-[#f1ebdd]" : "text-[#2c3a31] hover:text-[#c4703f] hover:bg-[#f1ebdd]/60"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>
        <div className="hidden lg:flex items-center gap-3">
          <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="flex items-center gap-2 text-[15px] font-semibold text-[#2c3a31] hover:text-[#c4703f] transition-colors" data-testid="header-phone">
            <Phone className="w-4 h-4" /> {CONTACT.phone}
          </a>
          <Link
            to="/rendez-vous"
            data-testid="header-cta"
            className="group inline-flex items-center gap-2 rounded-full bg-[#13261c] hover:bg-[#2a4636] text-white px-5 py-3 text-[15px] font-bold transition-colors shadow-[0_10px_24px_-10px_rgba(19,38,28,0.7)]"
          >
            <CalendarDays className="w-4 h-4" /> Prendre rendez-vous <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
          </Link>
        </div>
        <Sheet open={open} onOpenChange={setOpen}>
          <SheetTrigger asChild>
            <button className="lg:hidden p-2.5 rounded-xl hover:bg-[#f1ebdd]" aria-label="Menu" data-testid="mobile-menu-btn">
              <Menu className="w-6 h-6 text-[#13261c]" />
            </button>
          </SheetTrigger>
          <SheetContent side="right" className="w-[85%] sm:max-w-sm">
            <SheetTitle className="sr-only">Menu</SheetTitle>
            <div className="mt-6 flex flex-col gap-1">
              {LINKS.map((l) => (
                <NavLink key={l.to} to={l.to} end data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                  className={({ isActive }) => `px-4 py-3 rounded-xl text-lg font-semibold ${isActive ? "bg-[#f1ebdd] text-[#c4703f]" : "text-[#13261c]"}`}>
                  {l.label}
                </NavLink>
              ))}
              <Link to="/rendez-vous" data-testid="mobile-rdv" className="mt-4 text-center rounded-full bg-[#13261c] text-white px-5 py-3.5 font-bold">Prendre rendez-vous</Link>
              <Link to="/proprietaires" className="mt-2 text-center rounded-full bg-[#f1ebdd] text-[#13261c] px-5 py-3.5 font-bold">Découvrir mon potentiel</Link>
              <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="mt-2 text-center rounded-full border border-[#dccfb6] px-5 py-3.5 font-semibold text-[#c4703f]">{CONTACT.phone}</a>
            </div>
          </SheetContent>
        </Sheet>
      </div>
    </header>
  );
}
